import React, { useState, useEffect } from 'react';
import { Button } from './button';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils'; // Controleer dit pad

interface PollBannerProps {
  pollId: string;
  question: string;
  imageUrl?: string;
  onOpenPoll: () => void;
  onDismiss: () => void;
  className?: string;
}

// Key voor sessionStorage
const getStorageKey = (id: string) => `pollBannerDismissed_${id}`;

export const PollBanner: React.FC<PollBannerProps> = ({
  pollId,
  question,
  imageUrl,
  onOpenPoll,
  onDismiss,
  className,
}) => {
  const storageKey = getStorageKey(pollId);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Controleer sessionStorage
    try {
      const dismissed = sessionStorage.getItem(storageKey);
      if (!dismissed) {
        setIsVisible(true);
      }
    } catch (e) {
      console.warn("SessionStorage not available for poll banner.");
      setIsVisible(true);
    }
  }, [storageKey]);

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation(); // Voorkom dat openPoll ook wordt getriggerd
    setIsVisible(false);
    try {
      sessionStorage.setItem(storageKey, 'true');
    } catch (e) {
      console.warn("Could not save poll banner dismissal state.");
    }
    onDismiss(); // Callback naar parent indien nodig
  };
  
  const handleOpen = () => {
      onOpenPoll();
      // Optioneel: Banner direct verbergen na openen modal?
      // handleDismiss(); 
  }

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={cn(
        'bg-primary/10 border border-primary/30 text-primary-foreground p-4 rounded-lg shadow-md relative mb-6',
        'flex items-center gap-4 cursor-pointer hover:bg-primary/20 transition-colors',
        className
      )}
      onClick={handleOpen}
    >
      {/* Optionele Afbeelding */} 
      {imageUrl && (
          <img src={imageUrl} alt="Poll image" className="w-16 h-16 rounded-md object-cover" />
      )}
      {/* Poll Icoon (als geen afbeelding) */} 
      {!imageUrl && (
          <div className="flex-shrink-0 p-2 bg-primary/10 rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-primary">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg> 
          </div>
      )}
      <div className="flex-grow">
        <h4 className="font-semibold text-lg mb-1">Nieuwe Stemming!</h4>
        <p className="text-sm opacity-90">{question}</p>
      </div>
      <Button
        variant="secondary"
        size="sm"
        className="ml-auto mr-8 flex-shrink-0"
        onClick={handleOpen} // Zorg dat deze ook de modal opent
      >
          Stem nu
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="absolute top-2 right-2 h-7 w-7 text-primary/70 hover:text-primary hover:bg-primary/20"
        onClick={handleDismiss}
      >
        <X className="h-4 w-4" />
        <span className="sr-only">Sluiten</span>
      </Button>
    </div>
  );
}; 